var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{class:{
  'pb-4': _vm.options.paddingBottom,
  'border-bottom': _vm.options.borderBottom,
}},[_c('b-col',{staticClass:"w-100 d-flex justify-content-center"},_vm._l((_vm.filteredSteps),function(step,index){return _c('div',{key:step.name,staticClass:"text-center"},[_c('span',{class:{
          'step-badge': true,
          'primary-background-color': true,
          'mx-2': true,
          'inactive': index > _vm.currentIndex,
        }},[(index >= _vm.currentIndex)?_c('span',[_vm._v(_vm._s(index + 1))]):_c('font-awesome-icon',{attrs:{"icon":"check"}})],1),_vm._v(" "),_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(step.displayName))]),_vm._v(" "),(index < _vm.filteredSteps.length - 1)?_c('hr',{staticClass:"seperator"}):_vm._e()])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec1325c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/OnboardingStepper.vue
// module id = EYDv
// module chunks = 0 26 28 29 30 45 64